const minuteCountdown = 3
const warningThresholdPercent = 50
const criticalThresholdPercent = 80

export const calculateMSThreshold = (second: number, percent: number) =>
  second * 1000 * (1 - percent / 100)

export const countdownAttributesConstants = {
  minuteCountdown,
  warningThresholdPercent,
  criticalThresholdPercent,
  calculateMSThreshold: calculateMSThreshold,
  warningThresholdMS: calculateMSThreshold(
    minuteCountdown,
    warningThresholdPercent
  ),
  criticalThresholdMS: calculateMSThreshold(
    minuteCountdown,
    criticalThresholdPercent
  ),
}
